import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { KYMW6900Component } from "./kymw6900.component";
import { PagenationModel } from "./vo/pagenation.model";
import { ProposalModel } from "./vo/proposal.model";
import { SearchParamsModel } from "./vo/search-params.model";

const blankOption = { UserNmKanji: "", UserId: "" };
interface Buyer {
  UserId: string;
  UserNmKanji: string;
}

interface CodeMasterP {
  CodeDiv: string;
  CodeValue: string;
  CodeName: string;
  CodeDivName: string;
  codeValueName: string;
  Reserve1: string;
  Reserve2: string;
  ReserveNum1: string;
  ReserveNum2: string;
  SortNum: string;
  StartOrderCode: string;
  EndOrderCode: string;
}

interface ClassCode {
  ClassDivNum: string;
  ClassCode: string;
  ClassName: string;
  LargeClassCode: string;
  LargeClassName: string;
  MiddleClassCode: string;
  MiddleClassName: string;
  SmallClassCode: string;
  SmallClassName: string;
  ClassCodeName: string;
}

export class KYMW6900Model {
  static readonly ASSOCIATED_USER_TYPE_SUPPLIER = KYMW00Model.ASSOCIATED_USER_TYPE_SUPPLIER;
  static readonly USER_CLASS_LEADER = '0';
  static readonly USER_CLASS_STAFF = '1';
  static readonly USER_CLASS_AGENT = '2';

  static readonly PROPOSAL_STATUS_PROPOSAL_BEFORE = '0';
  static readonly PROPOSAL_STATUS_PROPOSING = '1';
  static readonly PROPOSAL_STATUS_BUYER_APPROVED = '2';
  static readonly PORPOSAL_STATUS_BUYER_REJECTED = '3';
  static readonly PROPOSAL_STATUS_LEADER_APPROVED = '4';
  static readonly PROPOSAL_STATUS_LEADER_REJECTED = '5';


  kymw6900Component: KYMW6900Component;
  proposalStatusList: CodeMasterP[] = [];
  classCodeList: ClassCode[] = [];
  masterInputStatusList: CodeMasterP[] = [];
  proposalUserList: { AssociatedUserId: string, AssociatedUserName: string; }[] = [];
  buyerList = [blankOption];
  clientUserName = '';
  searchParams = new SearchParamsModel();
  // 検索ボタン押下後の検索条件を保持するパラメータ
  afterSearchParams = new SearchParamsModel();
  confirmedSearchParams = new SearchParamsModel();
  proposalList: ProposalModel[] = [];
  pagenation = new PagenationModel(1, 0, 0, 0);
  selectedProposalIds: string[] = [];
  isHeaderChecked = false;
  loginUser: { userId: string, associatedUserType: string, userClassList?: { classCode: string; userClass: string; }[]; };
  buyerName = '';

  selectAllProposalIds() {
    this.selectedProposalIds = this.proposalList.map(proposal => proposal.proposalId);
    this.isHeaderChecked = true;
  }
  clearSelectedProposalIds() {
    this.selectedProposalIds = [];
    this.isHeaderChecked = false;
  }
  setDefaultSelectedProposalId(proposalId: string) {
    this.selectedProposalIds = [proposalId];
  }
  isSelected(proposalId: string) {
    return this.selectedProposalIds.includes(proposalId);
  }
  updateIsHeaderChecked() {
    this.isHeaderChecked = this.selectedProposalIds.length === this.proposalList.length;
  }

  setLists(proposalStatusList: CodeMasterP[], masterInputStatusList: CodeMasterP[], classCodeList: ClassCode[]) {
    if (!this.proposalStatusList.length) {
      this.setProposalStatusList(proposalStatusList);
    }
    if (!this.masterInputStatusList.length) {
      this.setMasterInputStatusList(masterInputStatusList);
    }
    if (!this.classCodeList.length) {
      this.setClassCodeList(classCodeList);
    }
  }

  getMasterInputStatus(masterInputId?: string) {
    if (masterInputId) {
      return this.masterInputStatusList.find(status => status.CodeValue === '1').CodeName ?? '';
    } else {
      return this.masterInputStatusList.find(status => status.CodeValue === '0').CodeName ?? '';
    }
  }

  private setProposalStatusList(statusList: CodeMasterP[]) {
    this.proposalStatusList = [...statusList].filter(s => s.CodeValue);
  }

  private setMasterInputStatusList(statusList: CodeMasterP[]) {
    this.masterInputStatusList = [...statusList].filter(s => s.CodeValue);
  }

  private setClassCodeList(classCodeList: ClassCode[]) {
    this.classCodeList = [...classCodeList].filter(c => c.ClassCode);
  }

  clearbuyer() {
    this.searchParams.buyerId = '';
  }

  updateBuyerList(buyerList: Buyer[]) {
    this.buyerList = [blankOption, ...buyerList];
  }

  isClient() {
    return this.loginUser?.associatedUserType === KYMW6900Model.ASSOCIATED_USER_TYPE_SUPPLIER;
  }

  isBuyer() {
    return !this.isGroupLeader() && !!this.loginUser.userClassList.find(userClass => {
      return userClass.userClass === KYMW6900Model.USER_CLASS_STAFF
        || userClass.userClass === KYMW6900Model.USER_CLASS_AGENT;
    });
  }

  isGroupLeader() {
    return !!this.loginUser.userClassList.find(userClass => userClass.userClass === KYMW6900Model.USER_CLASS_LEADER);
  }

  userId() {
    return this.loginUser.userId;
  }

  setBuyerName(name: string) {
    this.buyerName = name;
  }

  isBuyerApproved() {
    return this.selectedProposalIds.every(proposalId => {
      const proposal = this.proposalList.find(p => p.proposalId === proposalId);
      return proposal.proposalStatus.code === KYMW6900Model.PROPOSAL_STATUS_BUYER_APPROVED ? true : false;
    });
  }

  /**
   * 検索ボタン押下時の検索条件を保持するメソッド
   */
  setAfterSearchParams() {
    this.afterSearchParams.proposalStatus = this.searchParams.proposalStatus;
    this.afterSearchParams.classCode = this.searchParams.classCode;
    this.afterSearchParams.proposalUserId = this.searchParams.proposalUserId;
    this.afterSearchParams.buyerId = this.searchParams.buyerId;
    this.afterSearchParams.goodsNameAndStandardName = this.searchParams.goodsNameAndStandardName;
    this.afterSearchParams.preferredStartOrderCode = this.searchParams.preferredStartOrderCode;
    this.afterSearchParams.preferredDelivCatalogId = this.searchParams.preferredDelivCatalogId;
    this.afterSearchParams.pcode = this.searchParams.pcode;
    this.afterSearchParams.masterInputStatus = this.searchParams.masterInputStatus;
  }
}